import React from 'react'
import ReactDOM from 'react-dom'
import UserService from './services/UserService'
import App from './App'

const renderApp = () => ReactDOM.render(<App />, document.getElementById('root'))

UserService.initKeycloak(renderApp)
